import { useCallback, useState } from 'react';
import { parseInAppCopilotAction } from 'copilot-toolkit/actions/parseInAppCopilotAction';
import { sendStreamActionApi } from '../api/ChatSpotV1StreamingApi';
import { getActionText } from 'copilot-toolkit/actions/getActionText';
import debounce from 'react-utils/debounce';
export const useStreamingAction = () => {
  const [isStreaming, setIsStreaming] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState();

  // Some streaming errors do not block the streaming process:
  const debouncedSetIsStreamingForError = debounce(setIsStreaming, 1000);
  const handleProgress = useCallback(progressEvent => {
    setResponse(() => {
      if (progressEvent.error) {
        return {
          message: progressEvent.message || '',
          messageId: progressEvent.id,
          sections: [{
            id: `${progressEvent.id}`,
            text: progressEvent.response,
            type: 'PLAIN_TEXT'
          }],
          error: progressEvent.error
        };
      } else {
        return {
          message: progressEvent.message || '',
          sections: progressEvent.sections,
          messageId: progressEvent.id,
          threadId: progressEvent.thread_id
        };
      }
    });
  }, []);
  const handleClose = useCallback((_, finalEvent) => {
    /** We only want to set the timestamp when we have finished streaming */
    if (finalEvent) {
      setResponse(prevState => {
        return Object.assign({}, prevState, {
          timestamp: finalEvent.created_at
        });
      });
    }
    setIsStreaming(false);
  }, []);
  const handleError = useCallback(err => {
    setError(err);
    debouncedSetIsStreamingForError(false);
  }, [debouncedSetIsStreamingForError]);
  const handleReset = useCallback(() => {
    setResponse(null);
  }, []);
  const sendAction = useCallback(({
    data,
    isRefresh = false
  }) => {
    setIsStreaming(true);
    if (isRefresh) {
      setResponse(() => {
        return {
          message: '',
          messageId: null,
          sections: [],
          timestamp: null
        };
      });
    }
    let messageAction = parseInAppCopilotAction(data.action);
    if (messageAction) {
      const title = messageAction.title || getActionText(messageAction);
      messageAction = Object.assign({}, messageAction, {
        title
      });
    }
    const requestData = Object.assign({}, data, {
      action: messageAction
    });
    sendStreamActionApi({
      data: requestData,
      onProgress: handleProgress,
      onClose: handleClose,
      onError: handleError
    });
  }, [handleProgress, handleClose, handleError]);
  return {
    sendAction,
    isStreaming,
    actionResponse: response,
    actionError: error,
    onReset: handleReset
  };
};